import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import LangContext, { i18n } from 'modules/shared/context/langContext'

import { Modal } from 'antd'

// Components
import FormManageStockBalanceIsDirty from '../../master-data/stock-balance/componants/FormManageStockBalanceIsDirty'

class UpdateSyncMorningStockModal extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const { visible, onCancel, payloadUpdate, serviceType } = this.props

    return (
      <Modal
        className='update-sync-morning-stock-modal'
        title={null}
        visible={visible}
        onCancel={() => {
          onCancel()
        }}
        okText={null}
        width={600}
        closable={true}
        footer={null}
        keyboard={false} // This prevents closing on escape
        maskClosable={false} // This prevents closing on blur
      >
        <FormManageStockBalanceIsDirty
          id={payloadUpdate.id}
          serviceType={serviceType}
          handleCancel={onCancel}
        />
      </Modal>
    )
  }
}

export default connect(
  ({ auth, ui: { language } }) => ({
    auth,
    language,
  }),
  {}
)(UpdateSyncMorningStockModal)
